export var logNonExistingComponentState = details => {
  // eslint-disable-next-line no-console
  console.warn("".concat(details.componentName, " with the props: ").concat(JSON.stringify(details.props), " is NOT SUPPORTED!"));
};
//# sourceMappingURL=log-utils.js.map